import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Text } from '@elseu/sdu-titan';
import styled, { css } from 'styled-components';
import { Button } from '../Button/Button.js';

/**
 * The styled component for the CardPricing component
 */
var StyledCardPricing = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    padding: ", ";\n    background: ", ";\n    box-shadow: 0 15px 25px rgba(88, 77, 52, 0.05), 0 5px 10px rgba(88, 77, 52, 0.05);\n    border-radius: ", ";\n    height: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    padding: ", ";\n    background: ", ";\n    box-shadow: 0 15px 25px rgba(88, 77, 52, 0.05), 0 5px 10px rgba(88, 77, 52, 0.05);\n    border-radius: ", ";\n    height: 100%;\n  "])), theme.spacing[8], theme.designTokens.colors.grey0, theme.borderRadius[2]);
});
/**
 * The content section of the CardPricing component
 */
var Content = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"], ["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"])));
/**
 * The header section of the CardPricing component
 */
var Header = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[6];
});
/**
 * The title section of the CardPricing component
 */
var Title = styled(Text)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 0;\n  margin-bottom: ", ";\n"], ["\n  margin: 0;\n  margin-bottom: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[2];
});
/**
 * The subtitle section of the CardPricing component
 */
var Subtitle = styled(Text)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));
/**
 * The price section of the CardPricing component
 */
var Price = styled(Text)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[6];
});
/**
 * The CardPricing component
 *
 * @param {CardPricingProps} props - The props for the CardPricing component.
 * @returns {JSX.Element} The CardPricing component.
 */
var CardPricing = function (_a) {
  var title = _a.title,
    subtitle = _a.subtitle,
    price = _a.price,
    usps = _a.usps,
    button = _a.button;
  return jsxs(StyledCardPricing, {
    children: [jsxs(Content, {
      children: [jsxs(Header, {
        children: [jsx(Title, {
          as: "h3",
          type: "headerSmall",
          children: title
        }), subtitle && jsx(Subtitle, {
          as: "span",
          type: "label",
          children: subtitle
        })]
      }), price && jsx(Price, {
        as: "h3",
        type: "headerMedium",
        children: price
      }), usps]
    }), button && jsx(Button, __assign({}, button, {
      isExternal: button.external
    }))]
  });
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

export { CardPricing, StyledCardPricing };
//# sourceMappingURL=CardPricing.js.map
